module.exports = __webpack_public_path__ + "adobe_logo.adea0a729cd63e5997aa6794370feeef.png";